import { useCallback, useRef } from 'react';
import type { PopupConfig, AnimationType, ThemeType, PoemData } from '@/types';

// ===== 诗词内容 =====
const POEMS: PoemData[] = [
  { content: '莫愁千里路，自有到来风。', origin: ' ', author: '钱珝', category: ' ' },
  { content: '如花似叶，岁岁年年，共占春风。', origin: ' ', author: '晏殊', category: ' ' },
  { content: '春风得意马蹄疾，一日看尽长安花。', origin: ' ', author: '孟郊', category: ' ' },
  { content: '山重水复疑无路，柳暗花明又一村。', origin: ' ', author: '陆游', category: ' ' },
  { content: '千淘万漉虽辛苦，吹尽狂沙始到金。', origin: ' ', author: '杜甫', category: ' ' },
  { content: '明月几时有，把酒问青天。', origin: ' ', author: '苏轼', category: ' ' },
  { content: '众里寻他千百度，蓦然回首，那人却在灯火阑珊处。', origin: ' ', author: '辛弃疾', category: ' ' },
  { content: '十年生死两茫茫，不思量，自难忘。', origin: ' ', author: '苏轼', category: ' ' },
  { content: '问君能有几多愁，恰似一江春水向东流。', origin: ' ', author: '李煜', category: ' ' },
  { content: '夜阑卧听风吹雨，铁马冰河入梦来。', origin: ' ', author: '陆游', category: ' ' },
  { content: '莫言下岭便无难，赚得行人错喜欢。', origin: ' ', author: '苏轼', category: ' ' },
  { content: '人生如逆旅，我亦是行人。', origin: ' ', author: '苏轼', category: ' ' },
  { content: '独立小桥风满袖，平林新月人归后。', origin: ' ', author: '纳兰性德', category: ' ' },
  { content: '山有木兮木有枝，心悦君兮君不知。', origin: ' ', author: '子晋', category: ' ' },
];
// ===== Chen 的祝福语内容 =====
const CHEN_BLESSINGS: PoemData[] = [
  { content: '祝你岁岁安康，年年如意。', origin: '新年祝福', author: 'From 我', category: '祝福-新年' },
  { content: '愿你的每一天都闪闪发光。', origin: '日常祝福', author: 'From 我', category: '祝福-日常' },
  { content: '生活如诗，愿你笑靥如常。', origin: '生活祝福', author: 'From 我', category: '祝福-生活' },
  { content: '岁月流转，希望你始终闪闪发光。', origin: '成长祝福', author: 'From 我', category: '祝福-成长' },
  { content: '每个日子都值得被好好对待。', origin: '励志祝福', author: 'From 我', category: '祝福-励志' },
  { content: '愿你永远保有那份热情与温柔。', origin: '品质祝福', author: 'From 我', category: '祝福-品质' },
  { content: '所有美好都在不远处等你。', origin: '期许祝福', author: 'From 我', category: '祝福-期许' },
  { content: '做一个有梦想的人，走出你的精彩。', origin: '梦想祝福', author: 'From 我', category: '祝福-梦想' },
  { content: '愿你的笑容永远灿烂如阳光。', origin: '笑容祝福', author: 'From 我', category: '祝福-笑容' },
  { content: '生活再难，也挡不住你闪闪发光。', origin: '坚持祝福', author: 'From 我', category: '祝福-坚持' },
];
const ZHANGQIAN_BLESSINGS: PoemData[] = [
  { content: '祝张倩：莫愁千里路，自有到来风。', origin: ' ', author: '钱珝 陈黄妞', category: ' ' },
  { content: '祝张倩：如花似叶，岁岁年年，共占春风。', origin: ' ', author: '晏殊 陈黄妞', category: ' ' },
  { content: '祝张倩：春风得意马蹄疾，一日看尽长安花。', origin: ' ', author: '孟郊 陈黄妞', category: ' ' },
  { content: '祝张倩：山重水复疑无路，柳暗花明又一村。', origin: ' ', author: '陆游 陈黄妞', category: ' ' },
  { content: '祝张倩：千淘万漉虽辛苦，吹尽狂沙始到金。', origin: ' ', author: '杜甫 陈黄妞', category: ' ' },
  { content: '祝张倩：愿我如星君如月，夜夜流光相皎洁。', origin: ' ', author: '范成大 陈黄妞', category: ' ' },
  { content: '祝张倩：众里寻他千百度，蓦然回首，那人却在灯火阑珊处。', origin: ' ', author: '辛弃疾 陈黄妞', category: ' ' },
  { content: '祝张倩：海阔凭鱼跃，天高任鸟飞。', origin: ' ', author: '阮阅 陈黄妞', category: ' ' },
  { content: '祝张倩：从今把定春风笑，且作人间长寿仙。', origin: ' ', author: '李鼐 陈黄妞', category: ' ' },
  { content: '祝张倩：洛阳亲友如相问，一片冰心在玉壶。', origin: ' ', author: '王昌龄 陈黄妞', category: ' ' },
  { content: '祝张倩：如月之恒，如日之升。', origin: ' ', author: '佚名 陈黄妞', category: ' ' },
  { content: '祝张倩：但愿人长久，千里共婵娟。', origin: ' ', author: '苏轼 陈黄妞', category: ' ' },
  { content: '祝张倩：但愿得，河清人寿！', origin: ' ', author: '顾贞观 陈黄妞', category: ' ' },
  { content: '祝张倩：彩笔题桐叶，佳句问平安。', origin: ' ', author: '吕渭老 陈黄妞', category: ' ' },
];
const CHENXU_BLESSINGS: PoemData[] = [
  { content: '祝陈旭：莫愁千里路，自有到来风。', origin: ' ', author: '钱珝 陈黄妞', category: ' ' },
  { content: '祝陈旭：如花似叶，岁岁年年，共占春风。', origin: ' ', author: '晏殊 陈黄妞', category: ' ' },
  { content: '祝陈旭：春风得意马蹄疾，一日看尽长安花。', origin: ' ', author: '孟郊 陈黄妞', category: ' ' },
  { content: '祝陈旭：山重水复疑无路，柳暗花明又一村。', origin: ' ', author: '陆游 陈黄妞', category: ' ' },
  { content: '祝陈旭：千淘万漉虽辛苦，吹尽狂沙始到金。', origin: ' ', author: '杜甫 陈黄妞', category: ' ' },
  { content: '祝陈旭：愿我如星君如月，夜夜流光相皎洁。', origin: ' ', author: '范成大 陈黄妞', category: ' ' },
  { content: '祝陈旭：众里寻他千百度，蓦然回首，那人却在灯火阑珊处。', origin: ' ', author: '辛弃疾 陈黄妞', category: ' ' },
  { content: '祝陈旭：海阔凭鱼跃，天高任鸟飞。', origin: ' ', author: '阮阅 陈黄妞', category: ' ' },
  { content: '祝陈旭：从今把定春风笑，且作人间长寿仙。', origin: ' ', author: '李鼐 陈黄妞', category: ' ' },
  { content: '祝陈旭：洛阳亲友如相问，一片冰心在玉壶。', origin: ' ', author: '王昌龄 陈黄妞', category: ' ' },
  { content: '祝陈旭：如月之恒，如日之升。', origin: ' ', author: '佚名 陈黄妞', category: ' ' },
  { content: '祝陈旭：但愿人长久，千里共婵娟。', origin: ' ', author: '苏轼 陈黄妞', category: ' ' },
  { content: '祝陈旭：但愿得，河清人寿！', origin: ' ', author: '顾贞观 陈黄妞', category: ' ' },
  { content: '祝陈旭：彩笔题桐叶，佳句问平安。', origin: ' ', author: '吕渭老 陈黄妞', category: ' ' },
];
const XIAMINGYE_BLESSINGS: PoemData[] = [
  { content: '祝夏明烨：莫愁千里路，自有到来风。', origin: ' ', author: '钱珝 陈黄妞', category: ' ' },
  { content: '祝夏明烨：如花似叶，岁岁年年，共占春风。', origin: ' ', author: '晏殊 陈黄妞', category: ' ' },
  { content: '祝夏明烨：春风得意马蹄疾，一日看尽长安花。', origin: ' ', author: '孟郊 陈黄妞', category: ' ' },
  { content: '祝夏明烨：山重水复疑无路，柳暗花明又一村。', origin: ' ', author: '陆游 陈黄妞', category: ' ' },
  { content: '祝夏明烨：千淘万漉虽辛苦，吹尽狂沙始到金。', origin: ' ', author: '杜甫 陈黄妞', category: ' ' },
  { content: '祝夏明烨：愿我如星君如月，夜夜流光相皎洁。', origin: ' ', author: '范成大 陈黄妞', category: ' ' },
  { content: '祝夏明烨：众里寻他千百度，蓦然回首，那人却在灯火阑珊处。', origin: ' ', author: '辛弃疾 陈黄妞', category: ' ' },
  { content: '祝夏明烨：海阔凭鱼跃，天高任鸟飞。', origin: ' ', author: '阮阅 陈黄妞', category: ' ' },
  { content: '祝夏明烨：从今把定春风笑，且作人间长寿仙。', origin: ' ', author: '李鼐 陈黄妞', category: ' ' },
  { content: '祝夏明烨：洛阳亲友如相问，一片冰心在玉壶。', origin: ' ', author: '王昌龄 陈黄妞', category: ' ' },
  { content: '祝夏明烨：如月之恒，如日之升。', origin: ' ', author: '佚名 陈黄妞', category: ' ' },
  { content: '祝夏明烨：但愿人长久，千里共婵娟。', origin: ' ', author: '苏轼 陈黄妞', category: ' ' },
  { content: '祝夏明烨：但愿得，河清人寿！', origin: ' ', author: '顾贞观 陈黄妞', category: ' ' },
  { content: '祝夏明烨：彩笔题桐叶，佳句问平安。', origin: ' ', author: '吕渭老 陈黄妞', category: ' ' },
];
const WUTONG_BLESSINGS: PoemData[] = [
  { content: '祝吴桐：莫愁千里路，自有到来风。', origin: ' ', author: '钱珝 陈黄妞', category: ' ' },
  { content: '祝吴桐：如花似叶，岁岁年年，共占春风。', origin: ' ', author: '晏殊 陈黄妞', category: ' ' },
  { content: '祝吴桐：春风得意马蹄疾，一日看尽长安花。', origin: ' ', author: '孟郊 陈黄妞', category: ' ' },
  { content: '祝吴桐：山重水复疑无路，柳暗花明又一村。', origin: ' ', author: '陆游 陈黄妞', category: ' ' },
  { content: '祝吴桐：千淘万漉虽辛苦，吹尽狂沙始到金。', origin: ' ', author: '杜甫 陈黄妞', category: ' ' },
  { content: '祝吴桐：愿我如星君如月，夜夜流光相皎洁。', origin: ' ', author: '范成大 陈黄妞', category: ' ' },
  { content: '祝吴桐：众里寻他千百度，蓦然回首，那人却在灯火阑珊处。', origin: ' ', author: '辛弃疾 陈黄妞', category: ' ' },
  { content: '祝吴桐：海阔凭鱼跃，天高任鸟飞。', origin: ' ', author: '阮阅 陈黄妞', category: ' ' },
  { content: '祝吴桐：从今把定春风笑，且作人间长寿仙。', origin: ' ', author: '李鼐 陈黄妞', category: ' ' },
  { content: '祝吴桐：洛阳亲友如相问，一片冰心在玉壶。', origin: ' ', author: '王昌龄 陈黄妞', category: ' ' },
  { content: '祝吴桐：如月之恒，如日之升。', origin: ' ', author: '佚名 陈黄妞', category: ' ' },
  { content: '祝吴桐：但愿人长久，千里共婵娟。', origin: ' ', author: '苏轼 陈黄妞', category: ' ' },
  { content: '祝吴桐：但愿得，河清人寿！', origin: ' ', author: '顾贞观 陈黄妞', category: ' ' },
  { content: '祝吴桐：彩笔题桐叶，佳句问平安。', origin: ' ', author: '吕渭老 陈黄妞', category: ' ' },
];
const DAIJIAYE_BLESSINGS: PoemData[] = [
  { content: '祝代佳烨：莫愁千里路，自有到来风。', origin: ' ', author: '钱珝 陈黄妞', category: ' ' },
  { content: '祝代佳烨：如花似叶，岁岁年年，共占春风。', origin: ' ', author: '晏殊 陈黄妞', category: ' ' },
  { content: '祝代佳烨：春风得意马蹄疾，一日看尽长安花。', origin: ' ', author: '孟郊 陈黄妞', category: ' ' },
  { content: '祝代佳烨：山重水复疑无路，柳暗花明又一村。', origin: ' ', author: '陆游 陈黄妞', category: ' ' },
  { content: '祝代佳烨：千淘万漉虽辛苦，吹尽狂沙始到金。', origin: ' ', author: '杜甫 陈黄妞', category: ' ' },
  { content: '祝代佳烨：愿我如星君如月，夜夜流光相皎洁。', origin: ' ', author: '范成大 陈黄妞', category: ' ' },
  { content: '祝代佳烨：众里寻他千百度，蓦然回首，那人却在灯火阑珊处。', origin: ' ', author: '辛弃疾 陈黄妞', category: ' ' },
  { content: '祝代佳烨：海阔凭鱼跃，天高任鸟飞。', origin: ' ', author: '阮阅 陈黄妞', category: ' ' },
  { content: '祝代佳烨：从今把定春风笑，且作人间长寿仙。', origin: ' ', author: '李鼐 陈黄妞', category: ' ' },
  { content: '祝代佳烨：洛阳亲友如相问，一片冰心在玉壶。', origin: ' ', author: '王昌龄 陈黄妞', category: ' ' },
  { content: '祝代佳烨：如月之恒，如日之升。', origin: ' ', author: '佚名 陈黄妞', category: ' ' },
  { content: '祝代佳烨：但愿人长久，千里共婵娟。', origin: ' ', author: '苏轼 陈黄妞', category: ' ' },
  { content: '祝代佳烨：但愿得，河清人寿！', origin: ' ', author: '顾贞观 陈黄妞', category: ' ' },
  { content: '祝代佳烨：彩笔题桐叶，佳句问平安。', origin: ' ', author: '吕渭老 陈黄妞', category: ' ' },
];
const KANGKANG_BLESSINGS: PoemData[] = [
  { content: '祝康康：莫愁千里路，自有到来风。', origin: ' ', author: '钱珝 陈黄妞', category: ' ' },
  { content: '祝康康：如花似叶，岁岁年年，共占春风。', origin: ' ', author: '晏殊 陈黄妞', category: ' ' },
  { content: '祝康康：春风得意马蹄疾，一日看尽长安花。', origin: ' ', author: '孟郊 陈黄妞', category: ' ' },
  { content: '祝康康：山重水复疑无路，柳暗花明又一村。', origin: ' ', author: '陆游 陈黄妞', category: ' ' },
  { content: '祝康康：千淘万漉虽辛苦，吹尽狂沙始到金。', origin: ' ', author: '杜甫 陈黄妞', category: ' ' },
  { content: '祝康康：愿我如星君如月，夜夜流光相皎洁。', origin: ' ', author: '范成大 陈黄妞', category: ' ' },
  { content: '祝康康：众里寻他千百度，蓦然回首，那人却在灯火阑珊处。', origin: ' ', author: '辛弃疾 陈黄妞', category: ' ' },
  { content: '祝康康：海阔凭鱼跃，天高任鸟飞。', origin: ' ', author: '阮阅 陈黄妞', category: ' ' },
  { content: '祝康康：从今把定春风笑，且作人间长寿仙。', origin: ' ', author: '李鼐 陈黄妞', category: ' ' },
  { content: '祝康康：洛阳亲友如相问，一片冰心在玉壶。', origin: ' ', author: '王昌龄 陈黄妞', category: ' ' },
  { content: '祝康康：如月之恒，如日之升。', origin: ' ', author: '佚名 陈黄妞', category: ' ' },
  { content: '祝康康：但愿人长久，千里共婵娟。', origin: ' ', author: '苏轼 陈黄妞', category: ' ' },
  { content: '祝康康：但愿得，河清人寿！', origin: ' ', author: '顾贞观 陈黄妞', category: ' ' },
  { content: '祝康康：彩笔题桐叶，佳句问平安。', origin: ' ', author: '吕渭老 陈黄妞', category: ' ' },
];
const HUACONGWEN_BLESSINGS: PoemData[] = [
  { content: '祝华从文：莫愁千里路，自有到来风。', origin: ' ', author: '钱珝 陈黄妞', category: ' ' },
  { content: '祝华从文：如花似叶，岁岁年年，共占春风。', origin: ' ', author: '晏殊 陈黄妞', category: ' ' },
  { content: '祝华从文：春风得意马蹄疾，一日看尽长安花。', origin: ' ', author: '孟郊 陈黄妞', category: ' ' },
  { content: '祝华从文：山重水复疑无路，柳暗花明又一村。', origin: ' ', author: '陆游 陈黄妞', category: ' ' },
  { content: '祝华从文：千淘万漉虽辛苦，吹尽狂沙始到金。', origin: ' ', author: '杜甫 陈黄妞', category: ' ' },
  { content: '祝华从文：愿我如星君如月，夜夜流光相皎洁。', origin: ' ', author: '范成大 陈黄妞', category: ' ' },
  { content: '祝华从文：众里寻他千百度，蓦然回首，那人却在灯火阑珊处。', origin: ' ', author: '辛弃疾 陈黄妞', category: ' ' },
  { content: '祝华从文：海阔凭鱼跃，天高任鸟飞。', origin: ' ', author: '阮阅 陈黄妞', category: ' ' },
  { content: '祝华从文：从今把定春风笑，且作人间长寿仙。', origin: ' ', author: '李鼐 陈黄妞', category: ' ' },
  { content: '祝华从文：洛阳亲友如相问，一片冰心在玉壶。', origin: ' ', author: '王昌龄 陈黄妞', category: ' ' },
  { content: '祝华从文：如月之恒，如日之升。', origin: ' ', author: '佚名 陈黄妞', category: ' ' },
  { content: '祝华从文：但愿人长久，千里共婵娟。', origin: ' ', author: '苏轼 陈黄妞', category: ' ' },
  { content: '祝华从文：但愿得，河清人寿！', origin: ' ', author: '顾贞观 陈黄妞', category: ' ' },
  { content: '祝华从文：彩笔题桐叶，佳句问平安。', origin: ' ', author: '吕渭老 陈黄妞', category: ' ' },
];
const QIANYITONG_BLESSINGS: PoemData[] = [
  { content: '祝钱怡彤：莫愁千里路，自有到来风。', origin: ' ', author: '钱珝 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：如花似叶，岁岁年年，共占春风。', origin: ' ', author: '晏殊 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：春风得意马蹄疾，一日看尽长安花。', origin: ' ', author: '孟郊 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：山重水复疑无路，柳暗花明又一村。', origin: ' ', author: '陆游 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：千淘万漉虽辛苦，吹尽狂沙始到金。', origin: ' ', author: '杜甫 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：愿我如星君如月，夜夜流光相皎洁。', origin: ' ', author: '范成大 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：众里寻他千百度，蓦然回首，那人却在灯火阑珊处。', origin: ' ', author: '辛弃疾 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：海阔凭鱼跃，天高任鸟飞。', origin: ' ', author: '阮阅 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：从今把定春风笑，且作人间长寿仙。', origin: ' ', author: '李鼐 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：洛阳亲友如相问，一片冰心在玉壶。', origin: ' ', author: '王昌龄 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：如月之恒，如日之升。', origin: ' ', author: '佚名 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：但愿人长久，千里共婵娟。', origin: ' ', author: '苏轼 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：但愿得，河清人寿！', origin: ' ', author: '顾贞观 陈黄妞', category: ' ' },
  { content: '祝钱怡彤：彩笔题桐叶，佳句问平安。', origin: ' ', author: '吕渭老 陈黄妞', category: ' ' },
];

// ===== 路由配置映射 =====
type RouteKey = 'poems' | 'chn' | 'ZhangQian' | 'ChenXu' | 'XiaMingYe' | 'WuTong' | 'DaiJiaYe'| 'KangKang' | 'HuaCongWen' | 'QianYiTong' |string;

const ROUTE_CONTENT_MAP: Record<RouteKey, PoemData[]> = {
  poems: POEMS,
  chen: CHEN_BLESSINGS,
  ZhangQian: ZHANGQIAN_BLESSINGS,
  ChenXu: CHENXU_BLESSINGS,
  XiaMingYe: XIAMINGYE_BLESSINGS,
  WuTong: WUTONG_BLESSINGS,
  DaiJiaYe: DAIJIAYE_BLESSINGS,
  KangKang: KANGKANG_BLESSINGS,
  HuaCongWen: HUACONGWEN_BLESSINGS,
  QianYiTong: QIANYITONG_BLESSINGS,
};

const THEMES: ThemeType[] = [
  'blue', 'green', 'orange', 'purple', 'pink', 'yellow', 
  'cyan', 'lime', 'red', 'teal', 'indigo', 'amber', 
  'rose', 'mint', 'peach', 'lavender', 'coral', 'sky', 'lemon'
];

const ANIMATIONS: AnimationType[] = [
  'top', 'bottom', 'left', 'right', 
  'topleft', 'topright', 'bottomleft', 'bottomright'
];

const getRandomItem = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];

const getRandomPosition = (): { top: number; left: number } => ({
  top: Math.random() * 70,
  left: Math.random() * 85,
});

/**
 * 根据路由名称获取内容数组
 * 如果路由不存在，默认返回 POEMS
 */
const getContentByRoute = (routeName: string): PoemData[] => {
  return ROUTE_CONTENT_MAP[routeName] || POEMS;
};

export const usePopupManager = (routeName: string = 'poems') => {
  const counterRef = useRef(0);
  const contentIndexRef = useRef(0);

  const createPopup = useCallback((): PopupConfig => {
    // 根据路由获取内容
    const content = getContentByRoute(routeName);
    
    // 循环从内容数组中获取项目
    const item = content[contentIndexRef.current % content.length];
    contentIndexRef.current++;

    const text = item.content;
    const author = item.author;

    return {
      id: `popup-${Date.now()}-${counterRef.current++}`,
      text,
      author,
      theme: getRandomItem(THEMES),
      animation: getRandomItem(ANIMATIONS),
      ...getRandomPosition(),
      duration: 20000,
    };
  }, [routeName]);

  return { createPopup };
};
